import { render, staticRenderFns } from "./LabelTopic.vue?vue&type=template&id=69a346de&scoped=true&"
import script from "./LabelTopic.vue?vue&type=script&lang=js&"
export * from "./LabelTopic.vue?vue&type=script&lang=js&"
import style0 from "./LabelTopic.vue?vue&type=style&index=0&id=69a346de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a346de",
  null
  
)

export default component.exports